import { useState, useEffect } from "react";
import { OnChangeParams } from "baseui/select";
import { DriverQuestionList } from "@api/graphql/generated/generated-types";
import useDriverQuestionListOptions from "@src/common/hooks/useDriverQuestionListOptions";

interface QuestionListOption {
  id: string;
  label: string;
}

interface UseDriverQuestionListSelectReturn {
  questionListOptions: QuestionListOption[];
  selectedQuestionList: DriverQuestionList | undefined;
  handleQuestionListChange: (params: OnChangeParams) => void;
  getQuestionListValue: (
    questionList: DriverQuestionList | undefined
  ) => QuestionListOption[] | undefined;
  loading: boolean;
}

export function useDriverQuestionListSelect(
  initialQuestionList?: DriverQuestionList | null
): UseDriverQuestionListSelectReturn {
  const [selectedQuestionList, setSelectedQuestionList] = useState<
    DriverQuestionList | undefined
  >(initialQuestionList || undefined);

  const { questionListOptions, questionListsLoading, questionListsData } =
    useDriverQuestionListOptions();

  useEffect(() => {
    if (initialQuestionList) {
      setSelectedQuestionList(initialQuestionList);
    } else {
      setSelectedQuestionList(undefined);
    }
  }, [initialQuestionList]);

  function getQuestionListValue(
    questionList: DriverQuestionList | undefined
  ): QuestionListOption[] | undefined {
    if (!questionList) return undefined;
    return [{ id: questionList.id, label: questionList.name }];
  }

  function handleQuestionListChange(params: OnChangeParams): void {
    if (!params.option || params.option.id === "") {
      setSelectedQuestionList(undefined);
      return;
    }
    const selectedList = questionListsData?.driverQuestionLists?.find(
      (item) => item.id === params.option?.id
    );
    if (selectedList) {
      setSelectedQuestionList(selectedList);
    }
  }

  return {
    questionListOptions,
    selectedQuestionList,
    handleQuestionListChange,
    getQuestionListValue,
    loading: questionListsLoading,
  };
}
